import { render, staticRenderFns } from "./popAction.vue?vue&type=template&id=d684d946&scoped=true&"
import script from "./popAction.vue?vue&type=script&lang=js&"
export * from "./popAction.vue?vue&type=script&lang=js&"
import style0 from "./popAction.vue?vue&type=style&index=0&id=d684d946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684d946",
  null
  
)

export default component.exports